module.exports = __webpack_public_path__ + "build/assets/lmroman12-regular-e937683ca491f2501f172b54eb0276f5.woff2";